import React, { useState } from "react";
import Constant from "../../../constant/constant";
import axios from "axios";
import "./ExamResult.css";
import "./GetResult.css";

const BATCHES = ["1", "2", "3", "4", "5"];

const GetResultPage = () => {
  const [batch, setBatch] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [doneInfo, setDoneInfo] = useState(null);

  const fetchBatchResults = async () => {
    if (!batch) {
      alert("Please select a batch!");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.get(
        `${Constant.API_BASE_URL}sentinix/api/exam/online-exams/checkresult/${batch}`
      );
      if (res.status === 200) {
        setDoneInfo({ batch, total: res.data?.totalStudents });
        setShowPopup(true);
      }
    } catch (err) {
      console.error("Error fetching results:", err);
      alert(err.response?.data?.error || "Something went wrong while fetching results!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ea-page">
      <div className="ea-header">
        <div>
          <h2>🧮 Get Results</h2>
          <p>Calculate scores for a batch from the answers students submitted.</p>
        </div>
      </div>

      <div className="ea-card gr-card">
        <div className="gr-icon">📝</div>
        <h3>Calculate batch results</h3>
        <p>
          Choose a batch and calculate. Scores are marked against the correct answers set on the
          Questions page, then appear on the Exam Result page.
        </p>

        <div className="gr-form">
          <div className="ea-field">
            <label>Batch</label>
            <select
              className="ea-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
            >
              <option value="">Select Batch</option>
              {BATCHES.map((b) => (
                <option key={b} value={b}>Batch {b}</option>
              ))}
            </select>
          </div>
          <button className="ea-btn" onClick={fetchBatchResults} disabled={loading}>
            {loading ? "Calculating..." : "Calculate Results"}
          </button>
        </div>

        <div className="gr-warn">
          ⚠️ Running this again replaces the previously saved results for the selected batch.
        </div>
      </div>

      {showPopup && (
        <div className="ea-overlay" onClick={() => setShowPopup(false)}>
          <div className="ea-modal gr-success" onClick={(e) => e.stopPropagation()}>
            <div className="gr-check">✅</div>
            <h3>Results ready</h3>
            <p>
              Batch {doneInfo?.batch} calculated
              {doneInfo?.total != null ? ` for ${doneInfo.total} student(s)` : ""}. You can now
              view them on the Exam Result page.
            </p>
            <button className="ea-btn" onClick={() => setShowPopup(false)}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GetResultPage;
